module.exports = __webpack_public_path__ + "static/img/openfail@2x.4f21276b.png";